import { useMachine } from "@xstate/react";
import { Button, Popup } from "devextreme-react";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { Machine } from "xstate";
import { api } from "../../../request/api";
import { AuthenticationResponse } from "../../../Types/AuthenticationResponse";
import { saveAuthentication } from "../../../_helpers/token";
import { InputEx } from "../../Inputs/InputEx";
import { InputLabel } from "../../Labels/InputLabel";
import notify from "devextreme/ui/notify";
import { LoadPanelFullScreen } from "../../LoadPanel/LoadPanelFullScreen";
import { ChangePasswordForm } from "./ChangePasswordForm";
import { ForgetPasswordForm } from "./ForgetPasswordForm";
import ScrollView from "devextreme-react/scroll-view";

const fetchMachine = Machine({
  id: "loginForm",
  initial: "idle",
  states: {
    idle: {
      on: {
        FETCH: "loading",
      },
    },
    loading: {
      on: {
        RESOLVE: "success",
        REJECT: "failure",
      },
    },
    success: {
      entry: "sigin",
    },
    failure: {
      on: {
        FETCH: "loading",
      },
    },
  },
});

interface IFormInputs {
  login: string;
  password: string;
}



const LoginForm: React.FC = () => {
  const history = useHistory();
  const [login, setLogin] = useState<string>();
  const { register, handleSubmit, errors } = useForm<IFormInputs>();
  const [loading, setLoading] = useState<boolean>(false);
  const [showChangePasswordPopup, setShowChangePasswordPopup] = useState<boolean>(false);
  const [forgetPassword, setForgetPassword] = useState(false);

  const [state, send] = useMachine(fetchMachine, {
    actions: {
      sigin: () => {
        history.push("/");
      },
    },
  });

  const onSubmit = async (formData: IFormInputs) => {
    send("FETCH");
    setLoading(true);
    try {
      const { data } = await api.post<AuthenticationResponse>("User/Login", {
        Login: formData.login,
        Password: formData.password,
      });
      if (data.token && data.success && !data.setNewPassword) {
        saveAuthentication(data.token, data.tokenTimeout, data.login);
        send("RESOLVE");
        notify("Zalogowano poprawnie", "success", 5000);
        setLoading(false);
        history.push("/");
      } else if (data.token && data.success && data.setNewPassword) {
        setLogin(data.login);
        setShowChangePasswordPopup(true);
        notify(data.message, "warning", 5000);
        setLoading(false);
      } else {
        setLoading(false);
        notify(data.message, "error", 5000);
      }
    } catch (exception) {
      setLoading(false);
      send("REJECT");
    }
  };
  return (
    <>
      <LoadPanelFullScreen visible={loading} />
      <div className="loginForm">
        <div className="loginWrap">
          <form onSubmit={handleSubmit(onSubmit)} className="align-self-center">
            <div className="loginTitle">Logowanie do panelu</div>
            <div className="form-group">
              <div className="loginInput">
                <InputLabel forHtml="email" message="Login" />
                <InputEx
                  type="text"
                  placeholder=""
                  name="login"
                  className="form-control"
                  aria-describedby="emailHelp"
                  inputRef={register({ required: "Login jest wymagany." })}
                />

                {errors.login?.type === "required" && (
                  <small id="emailHelp" className="form-text  text-danger">
                    Login jest wymagany.
                  </small>
                )}
              </div>
              <div className="passwordInput">
                <InputLabel forHtml="password" message="Hasło" />
                <InputEx
                  className="form-control"
                  type="password"
                  placeholder=""
                  name="password"
                  inputRef={register({ required: true })}
                  aria-describedby="passwordHelp"
                />

                {errors.password?.type === "required" && (
                  <small id="passwordHelp" className="form-text text-danger">
                    Hasło jest wymagane.
                  </small>
                )}
              </div>
            </div>


            <InputEx type="submit" className="btn btnSuccess" value="Zaloguj" />

            <Button
              text={"Zmień / Nadaj hasło"}
              onClick={() => setForgetPassword(true)}
            />
          </form>
        </div>
      </div>


      <Popup
        visible={forgetPassword}
        onHiding={() => setForgetPassword(false)}
        dragEnabled={false}
        closeOnOutsideClick={false}
        deferRendering={true}
        showCloseButton={true}
        showTitle={true}
        title={"Proszę ustawić nowe hasło"}
        container=".dx-viewport"
        width={"40%"}
        height={"550px"}

      >

        <ScrollView id={"scrollview"} className="popupScrollView">
          <ForgetPasswordForm login={login} />
        </ScrollView>
      </Popup>



      <Popup
        visible={showChangePasswordPopup}
        onHiding={() => setShowChangePasswordPopup(false)}
        dragEnabled={false}
        closeOnOutsideClick={false}
        deferRendering={true}
        showCloseButton={false}
        showTitle={true}
        title={"Proszę ustawić nowe hasło"}
        container=".dx-viewport"
        width={"40%"}
        height={"550px"}
      >

        <ScrollView id={"scrollview"} className="popupScrollView">
          <ChangePasswordForm login={login} />
        </ScrollView>
      </Popup>
    </>
  );
};

export { LoginForm };
